var _style, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconServ06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t\t.st0{clip-path:url(#SVGID_00000018916490201851888030000010631939481040231813_);fill:url(#SVGID_00000080885051883934078740000016140815140648748697_);}\n\t\n\t\t.st1{clip-path:url(#SVGID_00000165228018912627280620000010704756434220887219_);fill:url(#SVGID_00000095305755994791180090000001509165882495559834_);}\n\t\n\t\t.st2{clip-path:url(#SVGID_00000086680547922749659840000000125269093702755211_);fill:url(#SVGID_00000168813092643713785280000008276115825101971329_);}\n\t\n\t\t.st3{clip-path:url(#SVGID_00000060747559176976727750000007259415881381546631_);fill:url(#SVGID_00000108303873315338016510000011227951607163634335_);}\n\t\n\t\t.st4{clip-path:url(#SVGID_00000042005964959348757380000014197676331659034754_);fill:url(#SVGID_00000117662857458300413190000007381605921521866395_);}\n\t\n\t\t.st5{clip-path:url(#SVGID_00000055689429835351436370000004948025886696230045_);fill:url(#SVGID_00000059302701633979519770000007210997017007684790_);}\n\t\n\t\t.st6{clip-path:url(#SVGID_00000058581250579248932180000011029159779875444896_);fill:url(#SVGID_00000127015739347875098290000005841586051816816286_);}\n\t\n\t\t.st7{clip-path:url(#SVGID_00000023264078638739069730000015301731243270301098_);fill:url(#SVGID_00000011732018290591581610000013209614330004755870_);}\n\t\n\t\t.st8{clip-path:url(#SVGID_00000120518942726205531140000013844632132507347601_);fill:url(#SVGID_00000131350908937713711960000006961452450773441181_);}\n\t\n\t\t.st9{clip-path:url(#SVGID_00000172400015074802442820000004603464332714363056_);fill:url(#SVGID_00000062157719206736099480000006682850611070058114_);}\n\t\n\t\t.st10{clip-path:url(#SVGID_00000168101554013313964810000011752215190133764526_);fill:url(#SVGID_00000004510721946097613460000008015919850273824654_);}\n\t\n\t\t.st11{clip-path:url(#SVGID_00000148622669761851398480000009138355999208219298_);fill:url(#SVGID_00000001652898623624462250000006412418690518816901_);}\n\t\n\t\t.st12{clip-path:url(#SVGID_00000176740852057168247120000010156368300362292883_);fill:url(#SVGID_00000097498171414964699940000015616762205246034827_);}\n\t\n\t\t.st13{clip-path:url(#SVGID_00000025400865219166037300000012568463909619477896_);fill:url(#SVGID_00000100367493098374103540000017252675539421779107_);}\n\t\n\t\t.st14{clip-path:url(#SVGID_00000117651604826426814910000014963401112526413726_);fill:url(#SVGID_00000098209083621886881680000001247613144276892606_);}\n\t\n\t\t.st15{clip-path:url(#SVGID_00000026857446384338048670000004665481641063100824_);fill:url(#SVGID_00000019676725434986004040000000788123487079866261_);}\n\t\n\t\t.st16{clip-path:url(#SVGID_00000147940358490881018220000009110217247230147238_);fill:url(#SVGID_00000125581739788000884960000006048835427436256156_);}\n\t\n\t\t.st17{clip-path:url(#SVGID_00000156560771215822662960000011959081704610650509_);fill:url(#SVGID_00000133500123012953865070000007279012267872155815_);}\n\t\n\t\t.st18{clip-path:url(#SVGID_00000133525192077865835330000002617555800770743997_);fill:url(#SVGID_00000044869054989121211250000008350784102931750295_);}\n\t\n\t\t.st19{clip-path:url(#SVGID_00000133498808307019754800000000405316845585453197_);fill:url(#SVGID_00000064330863919507375960000015892176128638562970_);}\n\t\n\t\t.st20{clip-path:url(#SVGID_00000082352993715037955850000007653865942968990136_);fill:url(#SVGID_00000055665614778622017430000007813925234732943254_);}\n\t\n\t\t.st21{clip-path:url(#SVGID_00000033341031091728215650000007050613050794554801_);fill:url(#SVGID_00000073695523230842156720000003346402584052032670_);}\n\t\n\t\t.st22{clip-path:url(#SVGID_00000173861230223464398730000000894946375028219838_);fill:url(#SVGID_00000029026523915932598410000002552732385556522394_);}\n\t\n\t\t.st23{clip-path:url(#SVGID_00000154388673840134411780000011834043468532396701_);fill:url(#SVGID_00000026841829830887120760000015832335234760570284_);}\n\t\n\t\t.st24{clip-path:url(#SVGID_00000018948061128297971630000006485958712526655155_);fill:url(#SVGID_00000103234985956116356700000012155436229612179080_);}\n\t\n\t\t.st25{clip-path:url(#SVGID_00000107549818466438566170000004310289495662927766_);fill:url(#SVGID_00000007422081552247187450000014129384191074321319_);}\n\t\n\t\t.st26{clip-path:url(#SVGID_00000124155182615316257680000011883687258858178464_);fill:url(#SVGID_00000074401897953053171260000016309563246768529032_);}\n\t\n\t\t.st27{clip-path:url(#SVGID_00000127008911695230704400000005336903798942392470_);fill:url(#SVGID_00000163074014318218813540000015155187146765788330_);}\n\t\n\t\t.st28{clip-path:url(#SVGID_00000022534638533467524010000000380587210300668607_);fill:url(#SVGID_00000114789278271947352530000010821812987124585630_);}\n\t\n\t\t.st29{clip-path:url(#SVGID_00000135653607865086908400000000302582661231016090_);fill:url(#SVGID_00000089563737255097151550000005150711908796215175_);}\n\t\n\t\t.st30{clip-path:url(#SVGID_00000049203068087318631820000014390521577335526273_);fill:url(#SVGID_00000092442280689900571210000001951636916404600752_);}\n\t\n\t\t.st31{clip-path:url(#SVGID_00000088840036045601156790000006599245362187773887_);fill:url(#SVGID_00000146475922144329230410000006057054626384332200_);}\n\t\n\t\t.st32{clip-path:url(#SVGID_00000094578992068058987130000005706126720235479716_);fill:url(#SVGID_00000181773493174060420120000006099002983033146762_);}\n\t\n\t\t.st33{clip-path:url(#SVGID_00000121982067062553858120000015995949166498323090_);fill:url(#SVGID_00000049202429393995320010000016457700768304418714_);}\n\t\n\t\t.st34{clip-path:url(#SVGID_00000139287769740737779510000002740637186286033329_);fill:url(#SVGID_00000167392408662602605760000004071168617290885036_);}\n\t\n\t\t.st35{clip-path:url(#SVGID_00000114041280194923570580000014133506124236359099_);fill:url(#SVGID_00000015348942590258662790000004398494541791266176_);}\n\t\n\t\t.st36{clip-path:url(#SVGID_00000077298176125580529550000010983880840031778483_);fill:url(#SVGID_00000093136255798626764700000012052200127791766195_);}\n\t\n\t\t.st37{clip-path:url(#SVGID_00000115474983138082970670000013721235487003511427_);fill:url(#SVGID_00000141428906150526075240000016525790616215536033_);}\n\t\n\t\t.st38{clip-path:url(#SVGID_00000098941743414731794320000008619541622883291804_);fill:url(#SVGID_00000063603959049179632540000013015671434427773118_);}\n\t\n\t\t.st39{clip-path:url(#SVGID_00000116199758705832426100000018143786582286933133_);fill:url(#SVGID_00000073718128260010989980000004857260760804062885_);}\n\t\n\t\t.st40{clip-path:url(#SVGID_00000069393744495499054630000018248643579542848140_);fill:url(#SVGID_00000000185418164026457670000003671071910644283315_);}\n\t\n\t\t.st41{clip-path:url(#SVGID_00000019639785439377581910000003188389487105102521_);fill:url(#SVGID_00000153701175995380242180000000589616171542503568_);}\n\t\n\t\t.st42{clip-path:url(#SVGID_00000044888493379327300430000011614723286914268308_);fill:url(#SVGID_00000183216640644540486920000000262978208394378909_);}\n\t\n\t\t.st43{clip-path:url(#SVGID_00000029020172732888490440000012468317951945654958_);fill:url(#SVGID_00000032639709310462637300000004608977279311873442_);}\n\t\n\t\t.st44{clip-path:url(#SVGID_00000018938012614119942200000008441372544700759690_);fill:url(#SVGID_00000094612906568123372150000006515223384456457097_);}\n\t\n\t\t.st45{clip-path:url(#SVGID_00000109742577103737557300000012300011795262784420_);fill:url(#SVGID_00000116233043468305448170000000553019303322268573_);}\n\t\n\t\t.st46{clip-path:url(#SVGID_00000017511491792373505980000015323019332146470030_);fill:url(#SVGID_00000101102611777147628140000007574070063379341996_);}\n\t\n\t\t.st47{clip-path:url(#SVGID_00000088099177994338853140000008287590574190201752_);fill:url(#SVGID_00000114069366283943189690000016476669106610164413_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000168104961148419030890000005414703327767266494_",
    d: "M7,28.9c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7 h14.2c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.7-0.7-0.7H7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124146852868900270740000016562871440992484517_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.1055,
    y1: 37.6688,
    x2: 14.1055,
    y2: 13.1587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168104961148419030890000005414703327767266494_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000124146852868900270740000016562871440992484517_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000128469204549193341960000011020989437474662020_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168104961148419030890000005414703327767266494_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172417013281025169910000005786293314757608636_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.1055,
    y1: 37.6688,
    x2: 14.1055,
    y2: 13.1587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6.3,
    y: 28.9,
    style: {
      clipPath: "url(#SVGID_00000128469204549193341960000011020989437474662020_)",
      fill: "url(#SVGID_00000172417013281025169910000005786293314757608636_)"
    },
    width: 15.6,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000002352296438810944540000008301457614997656469_",
    d: "M30,27.7v0.9c0,0.4,0.3,0.7,0.7,0.7 c0.4,0,0.7-0.3,0.7-0.7v-0.9c0-0.4-0.3-0.7-0.7-0.7C30.3,27,30,27.3,30,27.7"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069378830929148500790000006437255706080157107_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.6844,
    y1: 37.6688,
    x2: 30.6844,
    y2: 13.1587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000002352296438810944540000008301457614997656469_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000069378830929148500790000006437255706080157107_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178906410463080565900000010991723290296738209_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000002352296438810944540000008301457614997656469_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165925127045705582920000004958654920135073193_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.6844,
    y1: 37.6688,
    x2: 30.6844,
    y2: 13.1587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 27,
    style: {
      clipPath: "url(#SVGID_00000178906410463080565900000010991723290296738209_)",
      fill: "url(#SVGID_00000165925127045705582920000004958654920135073193_)"
    },
    width: 1.4,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000072967003911534957130000003521106820325487525_",
    d: "M31.4,16.8c0-1.6,1.4-2.9,3.1-2.9H43 c1.7,0,3.1,1.3,3.1,2.9v16.3c0,1.6-1.4,2.9-3.1,2.9h-8.5c-1.7,0-3.1-1.3-3.1-2.9v-1.8c0-0.4-0.3-0.7-0.7-0.7 c-0.4,0-0.7,0.3-0.7,0.7v1.8c0,1.6-1.4,2.9-3.1,2.9H7c-1.7,0-3.1-1.3-3.1-2.9V20.2h23.9c0.4,0,0.7-0.3,0.7-0.7 c0-0.4-0.3-0.7-0.7-0.7H3.9v-2c0-1.6,1.4-2.9,3.1-2.9h19.9c1.7,0,3.1,1.3,3.1,2.9v4.5c0,0.4,0.3,0.7,0.7,0.7 c0.4,0,0.7-0.3,0.7-0.7v-1.1h12.6c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.7-0.7-0.7H31.4V16.8z M34.5,12.5c-1.6,0-3,0.8-3.8,2 c-0.8-1.2-2.2-2-3.8-2H7c-2.5,0-4.5,1.9-4.5,4.3v16.3c0,2.4,2,4.3,4.5,4.3h19.9c1.6,0,3-0.8,3.8-2c0.8,1.2,2.2,2,3.8,2H43 c2.5,0,4.5-1.9,4.5-4.3V16.8c0-2.4-2-4.3-4.5-4.3H34.5z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166671729912919243430000004333445302507094157_",
    gradientUnits: "userSpaceOnUse",
    x1: 25,
    y1: 37.6688,
    x2: 25,
    y2: 13.1587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072967003911534957130000003521106820325487525_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000166671729912919243430000004333445302507094157_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000133497636871148066430000017410252874218812860_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072967003911534957130000003521106820325487525_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038415387146696594690000017080857466738425002_",
    gradientUnits: "userSpaceOnUse",
    x1: 25,
    y1: 37.6688,
    x2: 25,
    y2: 13.1587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 12.5,
    style: {
      clipPath: "url(#SVGID_00000133497636871148066430000017410252874218812860_)",
      fill: "url(#SVGID_00000038415387146696594690000017080857466738425002_)"
    },
    width: 45,
    height: 24.9
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000018229666328876666420000011047606240852281995_",
    d: "M30,24.1V25c0,0.4,0.3,0.7,0.7,0.7 c0.4,0,0.7-0.3,0.7-0.7v-0.9c0-0.4-0.3-0.7-0.7-0.7C30.3,23.4,30,23.7,30,24.1"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028313149284830664800000008078232126475645356_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.6844,
    y1: 37.6688,
    x2: 30.6844,
    y2: 13.1587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018229666328876666420000011047606240852281995_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000028313149284830664800000008078232126475645356_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000159471852844270356290000002318896603613972633_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018229666328876666420000011047606240852281995_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075128393221647870500000014281790433621740688_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.6844,
    y1: 37.6688,
    x2: 30.6844,
    y2: 13.1587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 23.4,
    style: {
      clipPath: "url(#SVGID_00000159471852844270356290000002318896603613972633_)",
      fill: "url(#SVGID_00000075128393221647870500000014281790433621740688_)"
    },
    width: 1.4,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000143591183599868007280000010684772914969192100_",
    d: "M34.5,16.2c-0.4,0-0.7,0.3-0.7,0.7 c0,0.4,0.3,0.7,0.7,0.7h3.8c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.7-0.7-0.7H34.5z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035496889035928431450000003956424988726492044_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.3681,
    y1: 37.6688,
    x2: 36.3681,
    y2: 13.1587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000143591183599868007280000010684772914969192100_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000035496889035928431450000003956424988726492044_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000051367557695740881780000008859668656802503329_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000143591183599868007280000010684772914969192100_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084503807062198339290000015893064527189432706_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.3681,
    y1: 37.6688,
    x2: 36.3681,
    y2: 13.1587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 33.8,
    y: 16.2,
    style: {
      clipPath: "url(#SVGID_00000051367557695740881780000008859668656802503329_)",
      fill: "url(#SVGID_00000084503807062198339290000015893064527189432706_)"
    },
    width: 5.2,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000119090715106168375670000011244056532489444502_",
    d: "M7,16.2c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7 h9.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.7-0.7-0.7H7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015329776126629448630000015469171629668432262_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.7371,
    y1: 37.6688,
    x2: 11.7371,
    y2: 13.1587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119090715106168375670000011244056532489444502_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000015329776126629448630000015469171629668432262_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070816752410998805870000013697209108507018141_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119090715106168375670000011244056532489444502_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183942013466163018420000007806594905983638697_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.7371,
    y1: 37.6688,
    x2: 11.7371,
    y2: 13.1587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6.3,
    y: 16.2,
    style: {
      clipPath: "url(#SVGID_00000070816752410998805870000013697209108507018141_)",
      fill: "url(#SVGID_00000183942013466163018420000007806594905983638697_)"
    },
    width: 10.9,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000086654669873347878720000012920320550972009654_",
    d: "M7,31.6c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7 h9.5c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.7-0.7-0.7H7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121270653764459724750000013715354267480168581_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.7371,
    y1: 37.6688,
    x2: 11.7371,
    y2: 13.1587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000086654669873347878720000012920320550972009654_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000121270653764459724750000013715354267480168581_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103979881994828730750000012713695713353221252_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000086654669873347878720000012920320550972009654_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096019132705337589370000007319054010995196293_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.7371,
    y1: 37.6688,
    x2: 11.7371,
    y2: 13.1587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6.3,
    y: 31.6,
    style: {
      clipPath: "url(#SVGID_00000103979881994828730750000012713695713353221252_)",
      fill: "url(#SVGID_00000096019132705337589370000007319054010995196293_)"
    },
    width: 10.9,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000179616080771556763770000013357137154324440751_",
    d: "M40.6,30.4v1.8c0,0.4,0.3,0.7,0.7,0.7 c0.4,0,0.7-0.3,0.7-0.7v-1.8c0-0.4-0.3-0.7-0.7-0.7C40.9,29.8,40.6,30.1,40.6,30.4"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170999955491396400760000006102601922662630846_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.3423,
    y1: 37.6688,
    x2: 41.3423,
    y2: 13.1587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000179616080771556763770000013357137154324440751_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000170999955491396400760000006102601922662630846_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000135691875472424684820000014871053761474748046_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000179616080771556763770000013357137154324440751_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123414441745946120540000001660425366827157890_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.3423,
    y1: 37.6688,
    x2: 41.3423,
    y2: 13.1587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 40.6,
    y: 29.8,
    style: {
      clipPath: "url(#SVGID_00000135691875472424684820000014871053761474748046_)",
      fill: "url(#SVGID_00000123414441745946120540000001660425366827157890_)"
    },
    width: 1.4,
    height: 3.2
  })), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000102515193059469694300000003982129027448984472_",
    d: "M42.5,30.4v1.8c0,0.4,0.3,0.7,0.7,0.7 c0.4,0,0.7-0.3,0.7-0.7v-1.8c0-0.4-0.3-0.7-0.7-0.7C42.8,29.8,42.5,30.1,42.5,30.4"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159449643615002228310000010381607160366440106_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.2371,
    y1: 37.6688,
    x2: 43.2371,
    y2: 13.1587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000102515193059469694300000003982129027448984472_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000159449643615002228310000010381607160366440106_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067231226911271503570000017966215924302455453_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000102515193059469694300000003982129027448984472_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093137445840583980760000000969561667760828087_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.2371,
    y1: 37.6688,
    x2: 43.2371,
    y2: 13.1587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 29.8,
    style: {
      clipPath: "url(#SVGID_00000067231226911271503570000017966215924302455453_)",
      fill: "url(#SVGID_00000093137445840583980760000000969561667760828087_)"
    },
    width: 1.4,
    height: 3.2
  })), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000042008012463302825660000012662404935125071035_",
    d: "M37.8,30.4v1.8c0,0.4,0.3,0.7,0.7,0.7 c0.4,0,0.7-0.3,0.7-0.7v-1.8c0-0.4-0.3-0.7-0.7-0.7C38.1,29.8,37.8,30.1,37.8,30.4"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158708167439760463070000015372886577587920825_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.5003,
    y1: 37.6688,
    x2: 38.5003,
    y2: 13.1587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000042008012463302825660000012662404935125071035_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000158708167439760463070000015372886577587920825_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034047995741341318880000010828448623583515008_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000042008012463302825660000012662404935125071035_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053533810614189316010000007813593900059049098_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.5003,
    y1: 37.6688,
    x2: 38.5003,
    y2: 13.1587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 37.8,
    y: 29.8,
    style: {
      clipPath: "url(#SVGID_00000034047995741341318880000010828448623583515008_)",
      fill: "url(#SVGID_00000053533810614189316010000007813593900059049098_)"
    },
    width: 1.4,
    height: 3.2
  })), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000178891726770305286450000005358268420169457323_",
    d: "M33.5,30.4v1.8c0,0.4,0.3,0.7,0.7,0.7 c0.4,0,0.7-0.3,0.7-0.7v-1.8c0-0.4-0.3-0.7-0.7-0.7C33.8,29.8,33.5,30.1,33.5,30.4"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112629715264114265880000006313531109152351128_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.2371,
    y1: 37.6688,
    x2: 34.2371,
    y2: 13.1587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178891726770305286450000005358268420169457323_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000112629715264114265880000006313531109152351128_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165217776096511787310000012479999261809697164_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178891726770305286450000005358268420169457323_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067205157281578987000000002907129610307234186_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.2371,
    y1: 37.6688,
    x2: 34.2371,
    y2: 13.1587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 29.8,
    style: {
      clipPath: "url(#SVGID_00000165217776096511787310000012479999261809697164_)",
      fill: "url(#SVGID_00000067205157281578987000000002907129610307234186_)"
    },
    width: 1.4,
    height: 3.2
  })), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000045596763410240951240000010994859075256240770_",
    d: "M35.9,30.4v1.8c0,0.4,0.3,0.7,0.7,0.7 c0.4,0,0.7-0.3,0.7-0.7v-1.8c0-0.4-0.3-0.7-0.7-0.7C36.2,29.8,35.9,30.1,35.9,30.4"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009579200242360611740000008390830992757452957_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.6055,
    y1: 37.6688,
    x2: 36.6055,
    y2: 13.1587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000045596763410240951240000010994859075256240770_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000009579200242360611740000008390830992757452957_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026157616978448763840000016932594018107585439_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000045596763410240951240000010994859075256240770_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091694432821476981010000011448510784826612107_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.6055,
    y1: 37.6688,
    x2: 36.6055,
    y2: 13.1587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 35.9,
    y: 29.8,
    style: {
      clipPath: "url(#SVGID_00000026157616978448763840000016932594018107585439_)",
      fill: "url(#SVGID_00000091694432821476981010000011448510784826612107_)"
    },
    width: 1.4,
    height: 3.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServ06);
export default __webpack_public_path__ + "static/media/IconServ-06.528f6a8890a1650b43103c961de8ce2b.svg";
export { ForwardRef as ReactComponent };